module.exports = __webpack_public_path__ + "static/media/rotary-button.79667cfc.svg";